/**
 * @copyright   Alcedis GmbH
 * @version     SVN: $Id: body.js 132841 2018-05-25 12:25:32Z ahe $
 * @author      Dominik Winter <dwi@alcedis.de>
 */

/**
 * Define console functions, so it doesn't crash
 *
 * @see http://stackoverflow.com/questions/398111/javascript-that-detects-firebug
 */
!function () {
    var names = [
        "log", "debug", "info", "warn", "error", "assert", "dir", "dirxml", "group", "groupEnd", "time", "timeEnd",
        "count", "trace", "profile", "profileEnd"
    ];

    window.console = window.console || {};

    for (var i = 0; i < names.length; ++i) {
        window.console[names[i]] = window.console[names[i]] || function () {};
    }
}();

/**
 * #14918 fix for IE
 */
!function () {
    window.stop = window.stop || function () {
        document.execCommand("Stop");
    };
}();

/**
 * init global keys
 */
!function () {
    // Prevent backspace from navigating back
    document.onkeydown = function (e) {
        var
            tag  = (e.target.tagName + "").toLowerCase(),
            type = (e.target.type + "").toLowerCase()
        ;

        // if key was backspace and target tag was not an input tag
        if (
            e.which === 8 &&
            tag !== "textarea" && (
                tag !== "input" ||
                (tag === "input" && type === "checkbox")
            )
        ) {
            e.preventDefault();
        }
    };
}();

// Alcedis WindowManager
var windowManager = new afWindowManager;

/**
 * Many init functionalities after finished loading all files
 */
$(function () {
    // Error Handling
    document.onerror = window.onerror = function (msg, file, line, column) {
        console.trace();
        _logError({msg: msg, file: file, line: line, column: column});
    };

    // Sidebar
    $("#sidebar").sidebar({
        language:       pool.language,
        application:    pool.application,
        params:         [pool.params[0]]
    });

    // Close button after save
    $("#messages .close").click(function () {
        $($(this).parents("div").get(0)).slideUp();
        return false;
    });

    // Hints
    $(".bubbleable").afBubble();

    // Nice Buttons
    $("button").afButton();

    var $body = $("body");
    // Change the Cursor on Ajax Events
    $body.bind("ajaxSend", function () {
        $body.css("cursor", "wait");
    }).bind("ajaxComplete", function () {
        $body.css("cursor", "auto");
    });

    // Init Maintenance
    if (pool.controller !== "login") {
        var maintenance = JSON.parse(pool.maintenance);

        if (maintenance !== false && maintenance !== null) {
            $.afMaintenance = new afMaintenance({
                minutesLeft: maintenance.minutesLeft
            });
        }
    }

    // Init Screensaver
    if (pool.loadScreenSaver === true) {
        $.afScreenSaver = new afScreenSaver({
            delay: pool.screenlock
        });
    }

    // Toggle for long textarea texts
    alcedisEventHandler.instance.addEvents({
        afterFormOpen: function() {
            $("form span.textarea > span.value a.more").toggle(function() {
                var $this = $(this);
                $this.text(pool.i18n.grid_js.less);
                $this.parent().find("span").show();
            }, function() {
                var $this = $(this);
                $this.text(pool.i18n.grid_js.more);
                $this.parent().find("span").hide();
            });
        }
    });
});
